import {Request, IRequestOptions} from 'Core/Common/Request';
import {P} from 'Core/Common/Promise';
import { List } from 'underscore';
import { Deserialize, GenericDeserialize } from 'libs/cerialize';
import { PromptDto } from './Models/PromptDto';
import { MessageDto } from './Models/MessageDto';

export interface IDBAssistantMessageDto {
	Database?: any;
	ChatHistory: Array<MessageDto>;
}

export interface IHelpAssistantMessageDto {
	Message?: string;
	responseId: string;
	CommandId?: number;
	CommandToken?: string;
}


export interface ISQLAssistantMessage {
	Message?: string;
	responseId: string;
}

export interface IFunctionAssistantMessage {
	Message?: string;
	responseId: string;
}

export interface IGenerateAIDto {
	DBStructure: string;
}

export interface IStartPlanningMessageDto {
	EntityId: number;
	RecordId: number;
	ControlId: number;
	ResponseId: string;
}

export interface IStartSQLDto {
	SQL: string;
	Error: string;
	ResponseId: string;
}

export interface IStartFunctionAssistantDto {
	Function: string;
	Error: string;
	ResponseId: string;
}

export interface IStartWorkFlowMessageDto {
	EntityId: number;
	RecordId: number;
	ControlId: number;
}

export interface IStartGuestPlanningMessageDto {
	EntityId: number;
	RecordId: number;
	ResponseId: string;
	CommandId: number;
	CommandToken: string;
	IsChatSession: boolean;
}

export interface ICreateAppointmentDto {
	StartTime: string;
	EndTime: string;
	Name: string;
	Users: number[];
	EntityId: number;
	RecordId: number;
	CommandToken: string;
}

export interface ISaveWorkflowResult {
	EntityId: number;
	RecordId: number;
	ControlId: number;
	ThreadId: string;
	Token: string;
}

export interface IDeleteAppointmentDto {
	Token: string
}

export class AssistantApi {

static DeleteAppiontment(dto: IDeleteAppointmentDto): P.Promise<any> {
		var deferredResult = P.defer<any>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/DeleteAppointment',
				type: 'POST'
			},
			params: dto
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static CreateAppiontment(dto: ICreateAppointmentDto): P.Promise<any> {
		var deferredResult = P.defer<any>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/CreateAppointment',
				type: 'POST'
			},
			params: dto
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{			
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static CreateWorkflowThread(controlId: number): P.Promise<string> {
		var deferredResult = P.defer<string>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/CreateWorkflowThread',
				type: 'GET'
			},
			params: {
				controlId: controlId
			}
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static CreateSQLThread(refreshMetadata: boolean, databaseDefinintion: string): P.Promise<void> {
		var deferredResult = P.defer<void>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/CreateSQLThread',
				type: 'POST'
			},
			params: {
				databaseDefinition: databaseDefinintion,
				refreshMetadata: refreshMetadata
			}
		};

		Request.Send(requestParams)
			.then(() => {
				deferredResult.resolve(undefined);
			}).fail(err=>{
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static StartWorkflowChat(params: IStartWorkFlowMessageDto): P.Promise<string> {
		var deferredResult = P.defer<string>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/StartWorkflowChat',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static StartPlanningChat(params: IStartPlanningMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/StartPlanningChat',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static StartFunctionChat(params: IStartFunctionAssistantDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/StartFunctionChat',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static StartSQLChat(params: IStartSQLDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/StartSQLChat',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static StartGuestPlanningChat(params: IStartGuestPlanningMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/StartGuestPlanningChat',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static PlannerMessage(params: IHelpAssistantMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SendPlanningMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static SqlMessage(params: ISQLAssistantMessage): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SendSqlMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static SendFunctionMessage(params: IFunctionAssistantMessage): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SendFunctionMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}


	static GuestPlannerMessage(params: IHelpAssistantMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SendGuestPlanningMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static HelpAssistantMessage(params: IHelpAssistantMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SendMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static AssistantMessage(params: IDBAssistantMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/DataBaseDesignerApi/AssistantMessage',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(GenericDeserialize(data, PromptDto));
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static GenerateStructure(params: IDBAssistantMessageDto): P.Promise<PromptDto> {
		var deferredResult = P.defer<PromptDto>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/DataBaseDesignerApi/GenerateStructure',
				type: 'POST'
			}, params: params
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{				
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}

	static SaveWorkflowResult(dto: ISaveWorkflowResult): P.Promise<any> {
		var deferredResult = P.defer<any>();

		var requestParams: IRequestOptions = {
			proxy: {
				url: '/api/AssistantApi/SaveWorkflowResult',
				type: 'POST'
			},
			params: dto
		};

		Request.Send(requestParams)
			.then(data => {				
				deferredResult.resolve(data);
			}).fail(err=>{			
				let jsonResult = JSON.parse(err.message);
				deferredResult.reject({ message: jsonResult.ExceptionMessage || jsonResult.Message });
			});

		return deferredResult.promise();
	}
}